import {ConfigsProperties} from './index'

const config: ConfigsProperties = {
    BASE_API: '/',
    SHA1_SALT: '6sJJnUiq',
    QINIU_HOST: 'http://cdn-srm-test.xmiws.com/',
    MINIO_HOST: 'http://172.25.18.47:9000/fosun/',
    ENV_NAME: '开发环境'
}

export default config
